import React, { FC } from 'react';
import { UserRoleE } from '../../models/enums';
import { useAppSelector } from '../../store/hooks';
import { selectCurrentUser } from '../../store/selectors/authSelectors';
import { DEFAULT_ADVERTISER_AGENCY_ID } from '../../utils/constants';
import AccessRights from '../AccessRights/AccessRights';
import Icon from '../Icon/Icon';

type DollarSignPropTypes = {
    condition?: boolean;
    title?: string;
}

const DollarSign: FC<DollarSignPropTypes> = (props) => {
    const { condition = true, title = 'Billed' } = props;
    const user = useAppSelector(selectCurrentUser);
    return (
        <AccessRights
            accessFor={[UserRoleE.AdvertisingAgency, UserRoleE.GlobalAdmin, UserRoleE.GlobalAdminAndAdminContentManager]}
            condition={condition && (
                user.role === UserRoleE.AdvertisingAgency ? +user.id === DEFAULT_ADVERTISER_AGENCY_ID : true
            )}
        >
            <Icon name='dollar' title={title} />
        </AccessRights>
    );
};

export default DollarSign;